import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-navy-950 text-silver-100" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mjg9hk8s47lo" />
      <main data-id="element-2" data-mp="3rc9f0ac2njyt">
        <Hero data-id="element-3" data-mp="3rcj8i7wbs999" />
        <SocialProof data-id="element-4" data-mp="3rbzlwdvqcwow" />
        <Testimonials data-id="element-5" data-mp="3rdkgu4lyihna" />
        <ProblemSection data-id="element-6" data-mp="3recdzjv7cnfo" />
        <SystemSection data-id="element-7" data-mp="5ygolyg4xb6" />
        <ModulesSection data-id="element-8" data-mp="6817u0q2c9h" />
        <BonusSection data-id="element-9" data-mp="5gfrc0u9uwx" />
        <UrgencySection data-id="element-10" data-mp="82j0zgp5o9c" />
        <PricingSection data-id="element-11" data-mp="2zld2xbxu5jcl" />
        <MoreResults data-id="element-12" data-mp="2zm4yimrfnh2v" />
        <GuaranteeSection data-id="element-13" data-mp="2zmo6pbra6r3p" />
        <FAQ data-id="element-14" data-mp="2zng32ospcsv1" />
        <ClosingSection data-id="element-15" data-mp="33mf2xuzktzfm" />
        <SummaryTable data-id="element-16" data-mp="33lx0ggmbmoz9" />
        <FinalCta data-id="element-17" data-mp="33n6yx6x35z6f" />
      </main>
      <Footer data-id="element-18" data-mp="33oi1x4ipj2wh" />
      <PurchaseNotification data-id="element-19" data-mp="38m1gy6n8bjph" />
    </div>;
}